import { ethers } from "ethers";

let test;

import {get, set, readable, writable} from 'svelte/store';
import {
    provider,
    signer,
    address as myAddress,
    unlock,
    unlocked,
    onWalletChange,
    correct_network,
    wallet_injected, onUnlocked,
    target_mainnet
} from "./wallet.js";

// export let contractAddress = { //rinkeby
//     stonerCats: "0xDfBA4386c6929eECD4D7D9d50E529257f4A120b7",
//     posters: "0x90aD7BF1518ebCdee1De96F3FE1857e7BA7A97dd",
// }
// export let contractAddress = { //ropsten
//     stonerCats: "0xC64B4329db642C6c9C76B7bCDbC21682E4249257",
//     posters: "0x33F07f53dd972d2341465A2A5790a601768B7498",
// }
// export let contractAddress = { //gananche
//     stonerCats: "0x99682bE581953cA55eD8001a0d29fa1DaF99bCD0",
//     posters: "0xA7B3Cc31B9DCd682C6259B915e7feA0DC72980ad",
// }

// console.log(contractAddress.stonerCats);
export let contractAddress = { //mainnet
    stonerCats: "0xD4d871419714B778eBec2E22C7c53572b573706e",
    posters: "0xA58723E04Af0e1c38213036b321e1243F8E16336",
}

const MAINNET = {
    stonerCats: "0xD10ae0431a0C98b90138533316B9319ecFAEB458",
    posters:  "0x8430160B529bEa42711380D2358f776770Ac971C",
}

const ZERO =    "0x0000000000000000000000000000000000000000";


// export let first_block = 8859000;
// export let first_block = 10666767;
export let first_block = 0;

// export const correctAddress = contractAddress.drops === MAINNET.drops;
export const correctAddress = true;//

export const contractAbi = {
    stonerCats: ["event Approval(address indexed _owner,address indexed _approved,uint256 indexed _tokenId)","event ApprovalForAll(address indexed _owner,address indexed _operator,bool _approved)","event Migrate(uint256 indexed _tokenId)","event Mined(uint256 indexed _tokenId,bytes32 hash)","event Transfer(address indexed _from,address indexed _to,uint256 indexed _tokenId)","event Withdraw(uint256 indexed _tokenId,uint256 value)","function PREV_CHAIN_LAST_HASH() view returns(bytes32 )","function UNMIGRATED() view returns(uint256 )","function V2_TOTAL() view returns(uint256 )","function approve(address _approved,uint256 _tokenId) nonpayable","function balanceOf(address _owner) view returns(uint256 )","function getApproved(uint256 _tokenId) view returns(address )","function hashOf(uint256 _tokenId) view returns(bytes32 )","function isApprovedForAll(address _owner,address _operator) view returns(bool )","function migrate(uint256 _tokenId,uint256 _withdrawEthUntil) nonpayable","function migrateMultiple(uint256[] _tokenIds,uint256[] _withdrawUntil) nonpayable","function mine(uint256 nonce) payable","function name() view returns(string _name)","function ownerOf(uint256 _tokenId) view returns(address )","function safeTransferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes data) nonpayable","function setApprovalForAll(address _operator,bool _approved) nonpayable","function supportsInterface(bytes4 interfaceID) view returns(bool )","function symbol() view returns(string _symbol)","function tokenByIndex(uint256 _index) view returns(uint256 )","function tokenOfOwnerByIndex(address _owner,uint256 _index) view returns(uint256 )","function tokenURI(uint256 _tokenId) view returns(string )","function totalSupply() view returns(uint256 )","function transferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function withdraw(uint256 _tokenId,uint256 _withdrawUntil) nonpayable","function withdrawMultiple(uint256[] _tokenIds,uint256[] _withdrawUntil) nonpayable"],
    posters:  [
        "function claim(uint _tokenId) nonpayable",
        "function claimMultiple(uint[] _tokenIds) nonpayable",

        "function started() view returns(bool)",
        "function claimable(uint _tokenId) view returns(bool)",
        "function unclaimed(uint start_index, uint limit) view returns(uint[])",
        "function claimed(uint start_index, uint limit) view returns(uint[])",
    ],
}


let contract = {
    stonerCats: null,
    posters:  null,
}
let contractWithSigner = {
    stonerCats: null,
    posters:  null,
}
export let me;

const BN = ethers.BigNumber;

export let state = writable('initial'); //initial, loading, loaded, network, error

export function cleanAddress(address){
    return String(address).toLowerCase();
}

const transactions = {
    // hash:{
    //     status: "pending",
    //     func: "purchase", //purchase
    //     params: {},
    // }
}

export let _pending = false;
export let _requested = false;

export let pending = writable(_pending);
export let requested = writable(_requested);

export let _myPosters = {
    state: "initial",   //initial, loading, loaded, error
    list: [],
};
export let _myUnclaimed = {
    state: "initial", //initial, loading, loaded, error
    list: [],
};
export let _isStarted = {
    state: "initial", //initial, loading, loaded, error
    value: false,
}

export let myPosters = writable(_myPosters);
export let myUnclaimed = writable(_myUnclaimed);
export let isStarted = writable(_isStarted);



export async function updateMyPosters(){
    _myPosters.state = "loading";
    myPosters.set(_myPosters);

    let _claimed;
    try{
        _claimed = await claimed();
        _myPosters.list = _claimed;
        _myPosters.state = "loaded";
    }catch(e){
        _myPosters.state = "error";
    }
    myPosters.set(_myPosters);
}
export async function updateMyUnclaimed(){
    _myUnclaimed.state = "loading";
    myUnclaimed.set(_myUnclaimed);

    let _unclaimed;
    try{
        _unclaimed = await unclaimed();
        _myUnclaimed.list = _unclaimed;
        _myUnclaimed.state = "loaded";
    }catch(e){
        _myUnclaimed.state = "error";
    }
    myUnclaimed.set(_myUnclaimed);
}
export async function updateIsStarted(){
    _isStarted.state = "loading";
    isStarted.set(_isStarted);

    let _started;
    try{
        _started = await started();
        // console.log(_started);
        _isStarted.value = Boolean(_started);
        _isStarted.state = "loaded";
    }catch(e){
        _isStarted.state = "error";
        console.log(e);
    }
    isStarted.set(_isStarted);
}

async function checkStarted(){
    await updateIsStarted();

    if(!_isStarted.value){
        setTimeout(checkStarted,1000 * 30);
    }else{
        await updateMyUnclaimed();
        await updateMyPosters();
    }
}

export async function claimPosters(_count){
    if(!_count || _count > _myUnclaimed.list.length){
        //fail
    }

    if(_count === 1){
        // console.log(">>>",_myUnclaimed.list[0].toString());

        let owner = await ownerOfCat(_myUnclaimed.list[0].toString());
        // console.log("??>",owner);


        await claim(_myUnclaimed.list[0].toString());
    }else{
        let _toClaim = [];
        for(let i = 0; i < _count; i++){
            _toClaim.push( _myUnclaimed.list[i].toString());
        }
        // console.log(">>>",_toClaim);
        await claimMultiple(_toClaim);
    }

    await updateMyUnclaimed();
    await updateMyPosters();
}

async function unclaimed(start_index = 0, limit = 0) {
    return  await contractWithSigner.posters.unclaimed(start_index,limit);
}
async function claimed(start_index = 0, limit = 0) {
    return await contractWithSigner.posters.claimed(start_index,limit);
}
async function claimable(_tokenId) {
    return await contract.posters.claimable(_tokenId);
}

async function ownerOfCat(_tokenId) {
    return await contract.stonerCats.ownerOf(_tokenId);
}

async function started() {
    return await contract.posters.started();
}

const parsed_events = {};

const callbacks = {
    Transfer:       [],

    transaction: {
        Submit: [],
        Confirm: [],
        Fail: [],
        Cancel: [],
    },
}

export function onTransfer(callback){
    callbacks.Transfer.push(callback);
}
export function onTransactionSubmit(callback){
    callbacks.transaction.Submit.push(callback);
}
export function onTransactionConfirm(callback){
    callbacks.transaction.Confirm.push(callback);
}
export function onTransactionFail(callback){
    callbacks.transaction.Fail.push(callback);
}
export function onTransactionCancel(callback){
    callbacks.transaction.Cancel.push(callback);
}

function transactionSubmitted(func,params){
    for(let i = 0; i < callbacks.transaction.Submit.length; i++){
        callbacks.transaction.Submit[i](func,params);
    }
}
function transactionConfirmed(func,params){
    for(let i = 0; i < callbacks.transaction.Confirm.length; i++){
        callbacks.transaction.Confirm[i](func,params);
    }
}
function transactionFailed(func,params){
    for(let i = 0; i < callbacks.transaction.Fail.length; i++){
        callbacks.transaction.Fail[i](func,params);
    }
}
function transactionCancelled(func,params){
    for(let i = 0; i < callbacks.transaction.Cancel.length; i++){
        callbacks.transaction.Cancel[i](func,params);
    }
}


function Transferred(_from,_to,_tokenId){
    for(let i = 0; i < callbacks.Transfer.length; i++){
        callbacks.Transfer[i](_from,_to,_tokenId);
    }
}





function parse_Transfer(_from,_to,_tokenId){
    if(_from === me){

    }
    if(_to === me){

    }

    if(get(state) === "loaded"){
    }

    Transferred(_from,_to,_tokenId);
}

function clear_transaction(hash){
    if(!transactions[hash]) return;
    const func = transactions[hash].func;
    const params = transactions[hash].params;

    delete transactions[hash];
    _pending = false;
    pending.set(_pending);
    transactionConfirmed(func,params);
}

//
// let dropRegisterTxCallbacks = [];
// export function onRegisterDropTx(func){
//     dropRegisterTxCallbacks.push(func);
// }
// function dropRegisteredTx(params){
//     for(let i = 0; i < dropRegisterTxCallbacks.length; i++){
//         dropRegisterTxCallbacks[i](params);
//     }
// }


function parse_event(event){
    if(typeof event === "undefined") {
        return;
    }

    const index = event.logIndex+event.transactionHash.substr(1,12);

    if(parsed_events[index]) {
        return;
    }
    parsed_events[index] = true;

    if(transactions[event.transactionHash]){
        clear_transaction(event.transactionHash);
    }

    switch (event.event){
        case "Transfer":
            parse_Transfer(
                cleanAddress(event.args._from),
                cleanAddress(event.args._to),
                Number(event.args._tokenId._hex)
            );
            break;
        default:
            // console.log("Other event:",event.event);

            break
    }
}
export async function connect(){
    state.set('loading');

    contract.stonerCats = new ethers.Contract(contractAddress.stonerCats,contractAbi.stonerCats,provider);
    contract.posters    = new ethers.Contract(contractAddress.posters,contractAbi.posters,provider);

    contractWithSigner.stonerCats = contract.stonerCats.connect(signer);
    contractWithSigner.posters  = contract.posters.connect(signer);

    me = cleanAddress(get(myAddress));


    // await processPastEvents();

    // await log_data();

    // console.log('load my poster data');

    // await updateMyUnclaimed();
    // await updateMyPosters();

    await checkStarted();

    // contractWithSigner.posters.on( "Transfer" , (a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20)=>{
    //     let event;
    //     //default arguments variable isnt workin for some reason. this will do
    //     let args = [a0,a1,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20];
    //
    //     for(let a = 0; a < args.length; a++) {
    //         if (typeof args[a] === "object"
    //             && args[a].event === "Transfer") {
    //             event = args[a];
    //             break;
    //         }
    //     }
    //     if(!event) return;
    //     parse_event(event);
    // } );

    // console.log(contractWithSigner.listeners("RegisterDrop"));

    state.set('loaded');
}

function reset(){
    console.log("injetcted reset")


    _pending = false;
    pending.set(_pending);

    _requested = false;
    requested.set(_requested);

    for(let tx in transactions){
        delete transactions[tx];
    }

    for(let evt in parsed_events){
        delete parsed_events[evt];
    }
}

// async function processPastEvents(){
//     console.log("injected: process past events")
//     if(!contractWithSigner.posters) return;
//
//
//     let current_block = await provider.getBlockNumber();
//
//     loader_max.set(current_block - first_block);
//
//     // console.log(current_block);
//
//     // const interval = 50000;
//     const interval = 500000;
//     // const interval = 10000;
//
//     let pownft_filter1 = contractWithSigner.POWNFT.filters.Transfer();
//     let drops_filter1  = contractWithSigner.drops.filters.RegisterDrop();
//     let drops_filter2  = contractWithSigner.drops.filters.ClaimDrop();
//
//     ///5000
//     //0
//     // console.log('load events:');
//     let processed = [];
//
//     // let blockNumber = 0;
//
//
//     if(correctAddress){
//         console.log('first_block:',first_block);
//         for(let i = first_block; i < current_block - interval; i += interval){
//             loader_i.set(i - first_block + interval);
//
//             let all = await contractWithSigner.drops.queryFilter(
//                 [drops_filter1,
//                     drops_filter2
//                 ],
//                 i,
//                 i + (interval - 1)
//             );
//
//             all.forEach(evt => {
//                 parse_event(evt);
//             });
//         }
//         let all = await contractWithSigner.drops.queryFilter(
//             [drops_filter1,
//                 drops_filter2
//             ],
//             current_block - interval,
//         );
//         all.forEach(evt => {
//             parse_event(evt);
//         });
//
//     }else{
//         let all = await contractWithSigner.drops.queryFilter(
//             [drops_filter1,
//                 drops_filter2,
//                 // filter3,
//                 // filter4
//             ]
//         );
//         all.forEach(evt => {
//             parse_event(evt);
//         });
//     }
//
//     if(blockNumbers.length > 0){
//         let pownft_first_block = blockNumbers[0];
//
//         for(let i = pownft_first_block; i < current_block - interval; i += interval){
//             // loader_i.set(i - first_block + interval);
//
//             let all = await contractWithSigner.POWNFT.queryFilter(
//                 [pownft_filter1],
//                 i,
//                 i + (interval - 1)
//             );
//
//             all.forEach(evt => {
//                 parse_event(evt);
//             });
//         }
//         let all = await contractWithSigner.POWNFT.queryFilter(
//             [pownft_filter1],
//             current_block - interval,
//         );
//         all.forEach(evt => {
//             parse_event(evt);
//         });
//     }
//
//
//
// }


//Function

function cancel_transaction(){
    _requested = false;
    requested.set(_requested);

    transactionCancelled();
}
function request_transaction(){
    _requested = true;
    requested.set(_requested);
}
function register_transaction(tx){
    _requested = false;
    _pending = true;

    pending.set(_pending);
    requested.set(_requested);

    transactionSubmitted();

    await_failure(tx.hash);
}

const await_failure = async(hash) => {
    const failure = (await provider.waitForTransaction( hash )).status === 0;
    if(failure){
        fail_transaction(hash);
    }
}

function fail_transaction(hash){
    transactionFailed(transactions[hash].func,transactions[hash].params);

    _pending = false;
    pending.set(_pending);
}


function alert_error(e){
    switch(e.code){
        case 4001:
            ///cancel
            break;
        //TODO: default?
        case "INSUFFICIENT_FUNDS":
            alert("You don't have enough ETH to make this transaction");
            break;
        default:
            if(e.message.includes("execution reverted: difficulty")){
                alert("Error: Your mining result is no longer valid and your transaction will fail.");
            }else{
                alert("Metamask error: "+e.message);

            }
            break;

    }
}

export async function claim(_tokenId){
    if(_requested || _pending) return;
    request_transaction();

    try{
        const tx =  await contractWithSigner.posters.claim(_tokenId);
        register_transaction(tx);
        await tx.wait();
        clear_transaction(tx.hash);
    }catch(e){
        cancel_transaction();
        alert_error(e);
        return false;
    }
}
export async function claimMultiple(_tokenIds){
    if(_requested || _pending) return;
    request_transaction();


    try{
        const tx =  await contractWithSigner.posters.claimMultiple(_tokenIds);
        register_transaction(tx);
        await tx.wait();
        clear_transaction(tx.hash);
    }catch(e){
        cancel_transaction();
        alert_error(e);
        return false;
    }
}


async function unlockCallback(){
    if(!get(correct_network)){
        state.set("network");
    }else{
        await connect();
    }

    onWalletChange(async (correctNetwork)=>{
        reset();
        if(!correctNetwork){
            state.set("network");
        } else{
            await connect();
        }
    });
}

export default async function init() {
    if(typeof window.ethereum === "undefined"){
        console.log('not injected')
        return;
    }
    console.log('injected')

    onUnlocked(unlockCallback);

    await unlock();
}


init();